import React from "react";

const CreatePack = () => {
  return <div>CreatePack</div>;
};

export default CreatePack;
